import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ToastrService } from 'ngx-toastr';

import {Location} from '@angular/common';
import { CardService } from 'app/modules/card/services/card.service';

@Component({
  selector: 'esim',
  templateUrl: './esim.component.html',
  styleUrls: ['./esim.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class EsimComponent implements OnInit {
  public showLoader: boolean = false;
  isChecked: boolean = false; 

  
  public menuItems = [
    {
      'icon': 'esim1.png',
      'title': 'Instant Activation',
      'url': '',
    },
    {
      'icon': 'esim2.png',
      'title': 'Easy Top-Up Options',
      'url': '',
    },
    {
      'icon': 'esim3.png',
      'title': 'Seamless Coverage Across Borders',
      'url': '',
    },
    {
      'icon': 'esim4.png',
      'title': 'Secure and Hassle-free setup',
      'url': '',
    },
    {
      'icon': 'esim5.png',
      'title': 'No Hidden Fees',
      'url': '',
    },
    {
      'icon': 'esim6.png',
      'title': 'Hotspot Compatibility',
      'url': '',
    },
    {
      'icon': 'esim7.png',
      'title': 'Flexible Data Plans',
      'url': '',
    },
    {
      'icon': 'esim8.png',
      'title': '24/7 Customer Support',
      'url': '',
    },
    {
      'icon': 'esim9.png',
      'title': 'Support Multiple Devices',
      'url': '',
    },
  ];

 
  public esimItems = [
    {
      'icon': 'spec1.png',
      'title': 'Activation',
      'text': ' Automatic, activated when connected to a cellular network.',
      'url': '',
    },

    {
      'icon': 'spec6.png',
      'title': 'Tethering / Hotspot',
      'text': 'Yes depending on local Operator policy',
      'url': '',
    },

    {
      'icon': 'spec3.png',
      'title': 'Installation',
      'text': 'Scan a QR code.',
      'url': '',
    },
    {
      'icon': 'spec4.png',
      'title': 'Plan Type',
      'text': 'Data Prepaid',
      'url': '',
    },

    {
      'icon': 'spec7.png',
      'title': 'Technology',
      'text': ': eSIM',
      'url': '',
    },

    {
      'icon': 'spec8.png',
      'title': 'Speed',
      'text': '4G /5G',
      'url': '',
    },
    
    {
      'icon': 'spec2.png',
      'title': 'Activation Policy',
      'text': 'The validity period begins upon eSIM connection to a supported network.',
      'url': '',
    },
  
   
   
    {
      'icon': 'spec5.png',
      'title': 'Other',
      'text': 'FUP Policy applicable for Unlimited Plans per Day 1GB at Network provided speed and post 1GB it will throttle to 265kbps speed.',
      'url': '',
    },
  
   

  ];


  public activeTab: string = "";

  constructor(
    public router: Router,
    public toast: ToastrService,
    private _location: Location,
    public cardService: CardService
  ) { }

  ngOnInit(): void {
   
  }
  setActiveTab(tabIndex: string) {
    this.activeTab = tabIndex;
  }
  
  proceedToNextPage(pageUrl: string): void {
    this.router.navigate([pageUrl]);
  }

  goTobuyesim(orderType){
    let orderData = {"order":"ESIM", "orderType": orderType };
    sessionStorage.setItem(ConstantsKey.ADD_ON_ORDER_TYPE, JSON.stringify(orderData));
    this.router.navigate(['/buy-international-esim']);
  }
 /* onCheckboxChange() {
    console.log('Checkbox state:', this.isChecked);
  }

  claimNow() {
    let isStudentPayCard = sessionStorage.getItem(ConstantsKey.IS_STUDENT_PAY_CARD);

    if(isStudentPayCard) {
      this.proceedToESim(isStudentPayCard)
    } else {
      this.getAllCards();
    }
  }

  goToNewFeatures() {
    this._location.back();
  }
  
  getAllCards() {
    this.cardService.getAllCardDetail().subscribe(resp => {
      let cardList:any = resp.body;
      const isStudentPay = cardList.some(el => el.cardVendor === "WSFXSTUDENTSCC");
      if(isStudentPay) {
        this.proceedToESim("true");
        sessionStorage.setItem(ConstantsKey.IS_STUDENT_PAY_CARD, "true");
      } else {
        this.proceedToESim("false");
      }



    }, err => {
      this.showLoader = false;            
    });    
  }

  proceedToESim(isStudentPayCard) {
    if(this.isChecked) {
      if(isStudentPayCard && isStudentPayCard == 'true') {
        // this.toast.success('Coming soon!');
        this.router.navigate(["/international-esim"]);      
      } else {
        this.toast.error("Sorry! You do not have Student Pay Card");
      }
    } else {
      this.toast.error("Please accept terms and condition");
    }
  }*/

}
